import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const container = document.getElementById('root');

const app = (
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);

// react-snap prerenders each route to static HTML, so on a real page load
// `#root` already has content in it. Hydrating reuses that existing DOM;
// calling createRoot().render() unconditionally would instead wipe it and
// rebuild from scratch — not broken, but you'd lose the point of
// prerendering (a visible flash, and no head-start on paint).
if (container.hasChildNodes()) {
  ReactDOM.hydrateRoot(container, app);
} else {
  const root = ReactDOM.createRoot(container);
  root.render(app);
}

reportWebVitals();